module.exports = __webpack_public_path__ + "img/ruchnoj-instrument.80b2071b.svg";